<template lang="pug">
  .page.bg-alt
    section
      b-container
        h1 ACCOUNT
        b-nav
          b-nav-item(:to="{name: 'AccountProfile'}") PROFILE
          b-nav-item(:to="{name: 'AccountAddress'}") ADDRESS
          b-nav-item(:to="{name: 'AccountBankAccount'}") PAYMENT
          b-nav-item(:to="{name: 'AccountSettings'}") SETTINGS
          b-nav-item(@click="logout") LOGOUT
      b-container.pt-3
        router-view
</template>

<script>

import standardMix from '@/mixins/standardMix';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Account.vue